import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Skeleton } from '../ui/skeleton';

/**
 * Skeleton loader for inquiry/request cards
 */
const InquiryCardSkeleton = () => {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-4">
        <div className="flex justify-between items-start mb-3">
          {/* Vendor name and status */}
          <div className="flex-1">
            <Skeleton className="h-5 w-2/3 mb-2" />
            <Skeleton className="h-4 w-1/2" />
          </div>
          {/* Status badge */}
          <Skeleton className="h-6 w-20" />
        </div>
        
        {/* Event details */}
        <div className="space-y-2 mb-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
        
        {/* Action buttons */}
        <div className="flex gap-2">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-24" />
        </div>
      </CardContent>
    </Card>
  );
};

/**
 * List of skeleton cards for inquiries loading state
 */
export const InquiryListSkeleton = ({ count = 3 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, idx) => (
        <InquiryCardSkeleton key={idx} />
      ))}
    </div>
  );
};

export default InquiryCardSkeleton;
